import type { Plugin } from "unified";
import type { Parent } from "unist";

interface MarkdownNode {
  type: string;
  value?: string;
  children?: MarkdownNode[];
}

const isCjkCharacter = (value: string) =>
  /[\u3040-\u30ff\u3400-\u9fff\uff00-\uffef]/.test(value);

const normalizeSoftBreaks = (value: string) =>
  value.replace(/\s*\n\s*/g, (match, offset: number, source: string) => {
    const before = source[offset - 1] ?? "";
    const after = source[offset + match.length] ?? "";
    return isCjkCharacter(before) && isCjkCharacter(after) ? "" : " ";
  });

const normalizeNode = (node: MarkdownNode, insideListItem = false) => {
  const isInsideListItem = insideListItem || node.type === "listItem";

  if (isInsideListItem && node.type === "text" && node.value) {
    node.value = normalizeSoftBreaks(node.value);
  }

  node.children?.forEach((child) => {
    normalizeNode(child, isInsideListItem);
  });
};

export const remarkNormalizeListItemSoftBreaks: Plugin<[], Parent> = () => {
  return (tree) => normalizeNode(tree as MarkdownNode);
};
